import React, { useCallback, useEffect, useRef, useState } from 'react'
import SupportListWrapper from 'core/page/SupportListWrapper'
import { useTranslation } from 'react-i18next'
import {
  ResetUserResponse,
  ResetUserResponseError,
  clearSelectedCustomer,
  fetchEcommData,
  getConcepts,
  listCustomers,
  reimportConcepts,
  resendLinkStatus,
  resetFilters,
  resetUser,
  setSelectedCustomer,
  updateActivationStatus,
  updateAppId,
  updateEcommerceStatus,
  updateModuleID,
  updateOuName,
  updateQuery
} from '../state/actions'
import {
  ChildComponentData,
  CustomerInterface,
  FilersConstants,
  ecommerceInterface,
  extractedDataInterface
} from '@cbgms/api/modules/customers'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { useSearchCustomers } from '../hooks/use-search-customers'
import CustomMenu from '../../Profile/CustomMenu'
import { Button, Grid, Stack, Typography } from '@mui/material'
import { Dropdown, IDropdownOption, LoaderWithBackground } from '@carsys/ui'
import { Dispatch } from 'redux'
import ReimportConceptsConfirmDialog from './ReimportConceptsConfirmDialog'
import { RefreshDataFunc } from '@cbgms/components/grid/Knock/KnockDataLoader'
import { useNotifier } from '@cbgms/base/notifier'
import ResetActivationModal from 'app-support/LKQAdmin/Profile/ResetActivationModal'
import store from '../state/store'
import { getActivationStatusOptions, getInitialConcepts, getPackageUsageStatus } from './helpers/constants'
import { makeStyles } from '@mui/styles'
import { v4 as uuidv4 } from 'uuid'
import ResetUserModal from '../ResetUserModal'
import { IRootReducerState } from 'state/reducers'
import DeleteConfirmationPopup from '../../CustomerAlerts/components/DeleteConfirmationPopup'
import { onRowClassName } from '@cbgms/components/grid/Types'

const useStyles = makeStyles({
  title: {
    marginBottom: '10px',
    fontSize: 20,
    fontWeight: 700
  }
})

interface ChildComponentProps {
  onUpdate: (data: ChildComponentData) => void
}

interface IReimportResType {
  Status: string
  Message: string
}

export const CustomDataGrid: React.FC<ChildComponentProps> = ({ onUpdate }) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const history = useHistory()
  const location = useLocation<{ preserveProfileState?: boolean }>()
  const dispatch = useDispatch<Dispatch>()

  // Fresh entry (sidebar / another module) clears persisted filters & selection;
  // preserved only when returning from Edit Concept / Details, which pass preserveProfileState.
  const hasHandledEntryRef = useRef(false)
  if (!hasHandledEntryRef.current) {
    hasHandledEntryRef.current = true
    if (location.state?.preserveProfileState !== true) {
      store.dispatch(resetFilters())
      store.dispatch(updateQuery(''))
      store.dispatch(clearSelectedCustomer())
    }
  }

  const [seed, setSeed] = useState<string>(uuidv4())
  const handleReload = () => {
    setSeed(uuidv4())
  }

  const { getSearchComponent, apiSearchQuery, updateListBYDropDownFilters } = useSearchCustomers({ handleReload })
  const [custEosid, setCustEosid] = useState<string>('')
  const [custName, setCustName] = useState<string>('')
  const [custNo, setCustNo] = useState<string>('')
  const [shipToLocation, setShipToLocation] = useState<string>('')
  const [shipAddress, setShipAddress] = useState<string>('')
  const [OuName, setOuName] = useState<string>('')
  const [appId, setAppId] = useState<number | undefined>()
  const [salesRepEmail, setSalesRepEmail] = useState<string>('')
  const [isShow, setIsShow] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [open, setOpen] = useState<boolean>(false)
  const [position, setPosition] = useState<{ screenY: number; screenX: number }>({
    screenX: 0,
    screenY: 0
  })

  const [ecomTabData, setEcomTabData] = useState<ecommerceInterface | null>(null)
  const [extractedDataPass, setExtractedDataPass] = useState<extractedDataInterface | null>(null)
  const [conceptsList, setConceptsList] = useState<IDropdownOption[]>([
    { key: FilersConstants.NONE, value: FilersConstants.NONE, text: t('global.nofilters') }
  ])
  const email = useSelector((state: IRootReducerState) => state.auth?.user?.email)
  const selectedCustomer = store.getState().SelectedCustomer
  const [openReimportDialog, setOpenReimportDialog] = useState(false)
  const refreshData = useRef<RefreshDataFunc | undefined>(undefined)
  const notifier = useNotifier()
  const [modalOpen, setModalOpen] = useState(false)
  const [resetUserModalOpen, setResetUserModalOpen] = useState(false)
  const [status, setStatus] = useState<string | null>(null)
  const [Email, setEmail] = useState<string | null>(null)
  const [resetUserResponse, setResetUserResponse] = useState<ResetUserResponse | ResetUserResponseError>({} as ResetUserResponse)
  const [isResetAvailable, setIsResetAvailable] = useState(false)
  const [resetConfirmModalOpen, setResetConfirmModalOpen] = useState(false)
  const [resetModalConfirmActionPending, setResetModalConfirmActionPending] = useState(false)

  /**
   * Filter by concepts
   */
  const CONCEPTS = getInitialConcepts(t)
  const PACKAGE_USAGE_STATUS = getPackageUsageStatus(t)
  const ACTIVATION_STATUS_OPTIONS = getActivationStatusOptions(t)

  // Initialize from persisted store so filters survive returning from Edit Concept
  const [seletedConceptForFilter, setSelectedConceptForFilter] = useState<string | undefined>(
    store.getState().ModuleID || CONCEPTS[0].value
  )
  const [seletedEcommStatusForFilter, setSelectedEcommStatusForFilter] = useState<string | undefined>(
    store.getState().ActivationStatus || ACTIVATION_STATUS_OPTIONS[0].value
  )
  const [packageStatusForFilter, setPackageStatusForFilter] = useState<string | undefined>(
    store.getState().EcommerceStatus || PACKAGE_USAGE_STATUS[0].value
  )
  const [isFilterApplied, setIsFilterApplied] = useState(
    Boolean(store.getState().ModuleID || store.getState().ActivationStatus || store.getState().EcommerceStatus)
  )
  const App_Id = useSelector((state: IRootReducerState) => state.auth?.user?.AppId)
  const ou_name = useSelector((state: IRootReducerState) => state.auth?.user?.ou_name)
  store.dispatch(updateAppId(String(App_Id)))
  store.dispatch(updateOuName(String(ou_name)))
  const fetchConceptsList = async () => {
    const response = await dispatch(getConcepts(Number(App_Id)))
    response?.Data?.map((item: { ModuleID: string; ModuleName: string }) => {
      setConceptsList(prevState => [
        ...prevState,
        {
          key: item.ModuleID,
          value: item.ModuleID,
          text: item.ModuleName
        }
      ])
    })
  }

  useEffect(() => {
    fetchConceptsList()
  }, [])

  const handleConceptsFilterChange = (value: any) => {
    setSelectedConceptForFilter(value)
    store.dispatch(updateModuleID(value))
    setIsFilterApplied(
      value !== FilersConstants.NONE ||
        seletedEcommStatusForFilter !== FilersConstants.NONE ||
        packageStatusForFilter !== FilersConstants.NONE
    )
  }

  const handleEcommStatusFilterChange = (value: any) => {
    setSelectedEcommStatusForFilter(value)
    store.dispatch(updateActivationStatus(value))
    setIsFilterApplied(
      seletedConceptForFilter !== FilersConstants.NONE || value !== FilersConstants.NONE || packageStatusForFilter !== FilersConstants.NONE
    )
  }

  const handlePackageStatusFilterChange = (value: any) => {
    setPackageStatusForFilter(value)
    store.dispatch(updateEcommerceStatus(value))
    setIsFilterApplied(
      seletedConceptForFilter !== FilersConstants.NONE ||
        seletedEcommStatusForFilter !== FilersConstants.NONE ||
        value !== FilersConstants.NONE
    )
  }

  const refreshLoadData = () => {
    setSelectedConceptForFilter(CONCEPTS[0].value)
    setSelectedEcommStatusForFilter(ACTIVATION_STATUS_OPTIONS[0].value)
    setPackageStatusForFilter(PACKAGE_USAGE_STATUS[0].value)
    store.dispatch(updateEcommerceStatus(ACTIVATION_STATUS_OPTIONS[0].value))
    store.dispatch(updateActivationStatus(ACTIVATION_STATUS_OPTIONS[0].value))
    store.dispatch(updateModuleID(CONCEPTS[0].value))
    updateListBYDropDownFilters()
    setIsFilterApplied(false)
  }

  const handleApplyFilters = () => {
    updateListBYDropDownFilters()
  }

  /**
   * end of Filter by concepts
   */

  const fetchNew = useCallback(
    (extractedData: { CustEosID: string; OuName: string; AppId: string }) => {
      dispatch(fetchEcommData(extractedData)).then(response => {
        setEcomTabData(response?.Data || [])
      })
    },
    [dispatch]
  )

  const onDoubleClickF = (data: { Customer: CustomerInterface; SignUp?: { SalesRepEmail: string } }) => {
    const extractedData = {
      CustEosID: data.Customer.CustEosID,
      OuName: ou_name as string,
      AppId: String(App_Id)
    }
    setCustNo(data.Customer.CustNo)
    setCustName(data.Customer.CustName)
    setExtractedDataPass(extractedData)
    setIsShow(true)
    store.dispatch(
      setSelectedCustomer({
        custNo: data.Customer.CustNo,
        custName: data.Customer.CustName,
        custEosId: data.Customer.CustEosID,
        shipToLocation: data.Customer.ShipToLoc,
        shipAddress: data.Customer.ShipAddr,
        ouName: data.Customer.OuName,
        appId: Number(App_Id),
        salesRepEmail: data.SignUp?.SalesRepEmail,
        ecomTabData: null,
        extractedConcept: extractedData
      })
    )
    fetchNew(extractedData)
  }

  useEffect(() => {
    if (ecomTabData !== null && extractedDataPass !== null) {
      onUpdate({
        extractedDataPass,
        ecomTabData,
        isShow,
        custNo: custNo ?? '',
        custName
      })
    }
  }, [ecomTabData, extractedDataPass, isShow, onUpdate])

  useEffect(() => {
    const handleClickOutside = () => {
      setIsShow(false)
    }

    document.addEventListener('click', handleClickOutside)

    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [])

  const handleClose = () => {
    setOpen(false)
  }

  const handleReimportConcepts = async () => {
    setIsLoading(true)

    try {
      const { Data }: { Data: unknown } = await dispatch(
        reimportConcepts(String(App_Id), custEosid as string, custNo as string, shipToLocation as string, OuName as string, email as string)
      )
      const data = Data as IReimportResType

      if (data.Status === 'Success') {
        setOpenReimportDialog(true)
        setOpen(false)
      } else if (data.Status === 'Failed') {
        notifier.error(data.Message)
        handleReimportDialogClose()
      }
    } catch (err) {
      console.error('------ reimport api error ------', err)
      notifier.error(t('global.reimport_api_error'))
      handleReimportDialogClose()
    } finally {
      setIsLoading(false)
    }
  }

  const handleReimportDialogConfirm = () => {
    if (refreshData.current) {
      refreshData.current()
    }

    handleReimportDialogClose()
  }

  const handleReimportDialogClose = () => {
    setOpenReimportDialog(false)
    setOpen(false)
  }

  const navigateToDetails = () => {
    history.push(`/LKQ/Profile/Details`, {
      customerId: custNo,
      name: custName,
      address: shipAddress,
      custEosId: custEosid,
      shipToLoc: shipToLocation
    })
    handleClose()
  }

  const navigateToConcepts = () => {
    history.push(`/LKQ/Profile/ConceptManagement`, {
      customerId: custNo,
      name: custName,
      custEosId: custEosid,
      shipToLoc: shipToLocation
    })
    handleClose()
  }

  const onEdit = (e: any, data: { Customer: CustomerInterface; SignUp: { SalesRepEmail: string; CompletionStatus: string } }) => {
    if (!data.Customer || !data.Customer.CustEosID) {
      console.warn('Customer ID is missing or customer data is null')
      return
    }
    setCustEosid(data.Customer.CustEosID)
    setCustName(data.Customer.CustName)
    setCustNo(data.Customer.CustNo)
    setShipToLocation(data.Customer.ShipToLoc)
    setAppId(Number(App_Id))
    setShipAddress(data.Customer.ShipAddr)
    setOuName(data.Customer.OuName)
    setSalesRepEmail(data.SignUp.SalesRepEmail)
    setIsResetAvailable(
      data.SignUp.CompletionStatus === 'AUTH0_UPDATED' ||
        data.SignUp.CompletionStatus === 'AUTH0_COMPLETED' ||
        data.SignUp.CompletionStatus === 'PACKAGE_SUBSCRIBED'
    )
    setPosition({
      screenX: e.clientX,
      screenY: e.clientY
    })

    store.dispatch(
      setSelectedCustomer({
        custNo: data.Customer.CustNo,
        custName: data.Customer.CustName,
        custEosId: data.Customer.CustEosID,
        shipToLocation: data.Customer.ShipToLoc,
        shipAddress: data.Customer.ShipAddr,
        ouName: data.Customer.OuName,
        appId: Number(App_Id),
        salesRepEmail: data.SignUp.SalesRepEmail,
        ecomTabData: null,
        extractedConcept: null
      })
    )

    setOpen(true)
  }

  const getRowClassName: onRowClassName = row => {
    const customer = row.data?.Customer as CustomerInterface | undefined

    if (!customer || !selectedCustomer) {
      return
    }

    return customer.CustNo === selectedCustomer.custNo ? 'profile-selected-customer-row' : undefined
  }

  const handleResetUser = async () => {
    setResetModalConfirmActionPending(true)
    let response: ResetUserResponse | { error: { response: ResetUserResponseError } } = {} as
      | ResetUserResponse
      | { error: { response: ResetUserResponseError } }
    try {
      response = await dispatch(resetUser(custEosid, custNo, shipToLocation, OuName, String(appId), salesRepEmail))
      if (response) {
        setResetUserModalOpen(true)
        setResetUserResponse(response)
      }
    } catch (error: any) {
      setResetUserModalOpen(true)
      setResetUserResponse((error?.response.data as ResetUserResponse | ResetUserResponseError) || (error as ResetUserResponseError))
    } finally {
      setResetModalConfirmActionPending(false)
      setResetConfirmModalOpen(false)
    }
  }

  const handleModalOpen = async () => {
    try {
      const response = await dispatch(resendLinkStatus(custEosid as string, appId as number))

      if (response.Data.Status === 'Success' || response.Data.Status === 'New Customer' || response.Data.Status === 'Package Subscribed') {
        setModalOpen(true)
        handleClose()
        setStatus(response?.Data?.Status)
        setEmail(response?.Data?.Email)
      }
    } catch (error) {
      console.error('Error fetching status:', error)
    }
  }

  const handleModalClose = () => {
    setModalOpen(false)
  }

  const handleResetUserModalClose = () => {
    setResetUserModalOpen(false)
  }

  return (
    <div data-testid='customers-table'>
      <Typography variant='h6' className={classes.title}>
        {t('Customers.Profile')}
      </Typography>
      <LoaderWithBackground isLoading={isLoading} />

      <SupportListWrapper
        key={seed}
        scope='customers-profile'
        onMenu={onEdit}
        loadAction={listCustomers}
        onDoubleClick={onDoubleClickF}
        onRowClassName={getRowClassName}
        middleMenuItems={getSearchComponent()}
        translationKey='customers'
        predefinedSearch={apiSearchQuery}
        hideExport
        tabItems={
          <Grid sx={{ width: '120%' }}>
            <Stack direction='row' mt={3} mb={3} ml={2} sx={{ width: '100%' }} spacing={2}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={6} md={2.5}>
                  <Dropdown
                    sx={{ minWidth: 150, mx: 1 }}
                    placeholder={t('global.filter_by_concepts')}
                    data-testid='dropdown-concepts-filter'
                    label={t('global.filter_by_concepts')}
                    onChange={e => handleConceptsFilterChange(e.target.value)}
                    options={conceptsList}
                    value={seletedConceptForFilter}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Dropdown
                    sx={{ minWidth: 180, mx: 1 }}
                    placeholder={t('global.package_status')}
                    data-testid='dropdown-package_status'
                    label={t('global.package_status')}
                    onChange={e => handlePackageStatusFilterChange(e.target.value)}
                    options={PACKAGE_USAGE_STATUS}
                    value={packageStatusForFilter}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={2.5}>
                  <Dropdown
                    sx={{ minWidth: 150, mx: 1 }}
                    placeholder={t('global.ecomm_status')}
                    data-testid='dropdown-role-change'
                    label={t('global.ecomm_status')}
                    onChange={e => handleEcommStatusFilterChange(e.target.value)}
                    options={ACTIVATION_STATUS_OPTIONS}
                    value={seletedEcommStatusForFilter}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} mt={0.2}>
                  <Stack direction='row'>
                    <Button
                      variant='contained'
                      color='primary'
                      className='ui tiny ml-half'
                      onClick={handleApplyFilters}
                      disabled={!isFilterApplied}
                    >
                      {t('global.apply_filters')}
                    </Button>

                    <Button variant='outlined' color='inherit' className='ui tiny ml-half' onClick={refreshLoadData}>
                      {t('global.reset')}
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </Stack>
          </Grid>
        }
        noDataPlaceholder={t('Customers.NoCustomerFound')}
        onDataLoaderInitialized={newRefreshdata => (refreshData.current = newRefreshdata)}
      />
      <CustomMenu
        open={open}
        handleClose={handleClose}
        handleReimportConcepts={handleReimportConcepts}
        navigateToDetails={navigateToDetails}
        position={position}
        navigateToConcepts={navigateToConcepts}
        onResetActivation={handleModalOpen}
        {...(isResetAvailable
          ? {
              onResetUser: () => {
                setResetConfirmModalOpen(true)
                handleClose()
              }
            }
          : {})}
      />

      <ReimportConceptsConfirmDialog
        open={openReimportDialog}
        onCancel={handleReimportDialogClose}
        onConfirm={handleReimportDialogConfirm}
      />

      <ResetActivationModal
        open={modalOpen}
        handleClose={handleModalClose}
        custNo={custNo ?? ''}
        status={status ?? ''}
        Email={Email ?? ''}
        shipToLoc={shipToLocation ?? ''}
        appId={appId ?? 0}
        custEosId={custEosid ?? ''}
        setLoading={setIsLoading}
      />
      <DeleteConfirmationPopup
        open={resetConfirmModalOpen}
        isLoading={resetModalConfirmActionPending}
        headerContent={t('CustomMenu.ResetCustomer')}
        paragrapghContent={t('ResetUser.ConfirmationPopUpMessage')}
        onCancel={() => setResetConfirmModalOpen(false)}
        onConfirm={handleResetUser}
      />
      <ResetUserModal open={resetUserModalOpen} handleClose={handleResetUserModalClose} resetUserResponse={resetUserResponse} />
    </div>
  )
}

export default CustomDataGrid
